export interface ExamplePreset {
  id: number;
  name: string;
  preview: string;
  results: string[];
}

export const examplePresets: ExamplePreset[] = [
  {
    id: 1,
    name: "Wrinkled Garment",
    preview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-wrinkle-removal%2Fwrinkle-removal-input-1.webp?alt=media&token=4dc98dfd-b0cc-46b4-9439-f23db0ada5ed",
    results: [
      "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-wrinkle-removal%2Fwrikle-remove-output-1.webp?alt=media&token=cc2ce7fc-d8ad-4c62-97f0-c9fe3fd739da"
    ]
  }
];
